import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

import {
  DialogCloseReason,
  SuiDialogBase,
  SuiDialogSimpleComponent,
  SuiDialogHeaderSlot,
  SuiDialogContentSlot,
  SuiDialogFooterSlot,
} from '@sui/dialog';
import { UtilsService } from 'src/app/core/services/utils.service';
import { SuiButtonComponent } from '@sui/button';

interface InvitationLinkDialogData {
  link: string;
}
interface InvitationLinkDialogResult {}

@Component({
  selector: 'app-invitation-link-dialog',
  templateUrl: './invitation-link-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './invitation-link-dialog.component.scss',
  imports: [
    SuiDialogSimpleComponent,
    SuiDialogHeaderSlot,
    SuiButtonComponent,
    SuiDialogContentSlot,
    SuiDialogFooterSlot,
    TranslatePipe,
  ],
})
export class InvitationLinkDialogComponent extends SuiDialogBase<
  InvitationLinkDialogData,
  InvitationLinkDialogResult
> {
  private translateService = inject(TranslateService);
  private utilsService = inject(UtilsService);

  title = this.translateService.instant('invitation-link-dialog.title');

  get link(): string {
    return this.dialogData.link;
  }

  cancel(): void {
    this.close({ reason: DialogCloseReason.Cancel });
  }

  copyToClipboard(): void {
    this.utilsService.copyToClipboard(this.link);
  }
}
